import { FLAG_TONE } from '../lib/constants.js';

export function ClockAlertsBanner({ alerts }) {
  if (!alerts || alerts.length === 0) return null;
  const tone = (priority) => priority === 'Critical' ? FLAG_TONE.red
                          : priority === 'High'     ? FLAG_TONE.yellow
                          : FLAG_TONE.gray;
  return (
    <div className="card" style={{ borderLeft: '4px solid #c62828', background: '#fff3e0' }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#bf360c', marginBottom: 6 }}>
        ⚠ {alerts.length} clock {alerts.length === 1 ? 'alert' : 'alerts'}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {alerts.slice(0, 5).map((a, i) => {
          const t = tone(a.priority);
          return (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12 }}>
              <span style={{ background: t.bar, color: '#fff', padding: '1px 8px', borderRadius: 8,
                             fontSize: 10, fontWeight: 700, textTransform: 'uppercase' }}>
                {a.priority}
              </span>
              <span style={{ color: '#37474f' }}>{a.message}</span>
            </div>
          );
        })}
        {alerts.length > 5 && (
          <div style={{ fontSize: 11, color: '#9e9e9e' }}>+{alerts.length - 5} more</div>
        )}
      </div>
    </div>
  );
}
